class CartRemoveButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener("click", (event) => {
      event.preventDefault();
      const cartItems = this.closest("cart-items") || this.closest("cart-drawer-items");
      
      // Get the unique ID and parent product ID if they exist
      const uniqueId = this.dataset.uniqueId;
      const parentProductId = this.dataset.parentProductId;
      
      if (parentProductId) {
        // If this is a bundle product, remove all related items
        const formData = {
          updates: {},
          sections: cartItems.getSectionsToRender().map((section) => section.section),
          sections_url: window.location.pathname
        };

        // First fetch current cart data to check properties
        fetch("/cart.js")
          .then(response => response.json())
          .then(cartData => {
            // Find all items that have matching _unique_id in their properties
            cartData.items.forEach(item => {
              if (item.properties && item.properties._unique_id === uniqueId) {
                formData.updates[item.variant_id] = 0;
              }
            });

            // Remove bundle data from localStorage
            if (uniqueId) {
              localStorage.removeItem(`bundle_${uniqueId}`);
            }


            // Update cart with all related items removed
            return fetch("/cart/update.js", {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify(formData),
            });
          })
          .then(response => response.json())
          .then(data => {
            const cartDrawer = document.querySelector("cart-drawer");
            if (cartDrawer) {
              // Update cart sections
              cartItems.getSectionsToRender().forEach((section) => {
                const elementToReplace = document.getElementById(section.id)?.querySelector(section.selector) || document.getElementById(section.id);
                if (elementToReplace) {
                  elementToReplace.innerHTML = cartItems.getSectionInnerHTML(
                    data.sections[section.section],
                    section.selector
                  );
                }
              });

              // Update cart drawer state
              if (data.item_count === 0) {
                cartDrawer.classList.add("is-empty");
              }

              // Force cart drawer to re-render with new data
              setTimeout(() => {
                const bundleItems = document.querySelectorAll('[data-bundle-id]');
                bundleItems.forEach(item => {
                  const bundleId = item.dataset.bundleId;
                  const bundleData = JSON.parse(localStorage.getItem(`bundle_${bundleId}`));
                  
                  if (bundleData) {
                    // Update parent product details
                    const parentImage = item.querySelector('.bundle-parent-image');
                    const parentTitle = item.querySelector('.bundle-parent-title');
                    if (parentImage) {
                      parentImage.src = bundleData._parent_product_image;
                      parentImage.alt = bundleData._parent_product_title;
                    }
                    if (parentTitle) {
                      parentTitle.textContent = bundleData._parent_product_title;
                    }
                    
                    // Update price details
                    const totalPrice = item.querySelector('.bundle-total-price');
                    const comparePrice = item.querySelector('.bundle-compare-price');
                    const discount = item.querySelector('.bundle-discount');
                    
                    if (totalPrice) {
                      totalPrice.textContent = `₹${bundleData._customized_total_price}`;
                    }
                    
                    if (bundleData._customized_compare_price && 
                        bundleData._customized_compare_price !== bundleData._customized_total_price) {
                      if (comparePrice) {
                        comparePrice.textContent = `₹${bundleData._customized_compare_price}`;
                        comparePrice.style.display = 'inline';
                      }
                      if (discount) {
                        discount.textContent = `${bundleData._customized_discount}% OFF`;
                        discount.style.display = 'inline';
                      }
                    }
                    
                    // Update items count
                    const itemsCount = item.querySelector('.bundle-items-count');
                    if (itemsCount) {
                      itemsCount.textContent = 
                          `View selected items (${bundleData._customized_items_count})`;
                    }
                    
                    // Update items list
                    const itemsList = item.querySelector('.bundle-items-list');
                    if (itemsList) {
                      itemsList.innerHTML = ''; // Clear existing items
                      const customizedItems = bundleData._customized_items.split('||');
                      
                      customizedItems.forEach(customizedItem => {
                        const [title, quantity, image, price, discount] = customizedItem.split('::');
                        
                        const itemElement = document.createElement('div');
                        itemElement.className = 'tw-mb-[1.6rem] tw-flex tw-gap-[1.2rem]';
                        itemElement.innerHTML = `
                            <div class="tw-w-[8rem] tw-h-[8rem] tw-flex-shrink-0">
                                <img
                                    src="${image}"
                                    alt="${title}"
                                    class="tw-w-full tw-h-full tw-object-cover"
                                    loading="lazy"
                                    width="60"
                                    height="60"
                                >
                            </div>
                            <div class="tw-flex tw-flex-col tw-gap-[0.4rem]">
                                <div class="tw-text-[1.2rem] tw-font-medium">${title}</div>
                                <div class="tw-flex tw-items-center tw-gap-[0.8rem]">
                                    <div class="tw-text-[1.2rem] tw-font-medium">₹${price}</div>
                                </div>
                                <div class="tw-text-[1.2rem] tw-text-[#9A9A9A]">Quantity: ${quantity}</div>
                            </div>
                        `;
                        
                        itemsList.appendChild(itemElement);
                      });
                    }
                  }
                });
              }, 100); // Small delay to ensure DOM is updated
            }

            // Update cart bubbles
            const cartBubble = document.querySelectorAll('#cart-icon-bubble');
            if (cartBubble) {
              // Update mobile cart count
              cartBubble.forEach(element => {
                const mobileBubble =  element.querySelector('.cart-count-bubble-mobile span[aria-hidden="true"]');
                const desktopBubble = element.querySelector('.cart-count-bubble span[aria-hidden="true"]');
                
                if (mobileBubble) {
                  mobileBubble.textContent = data.item_count;
                }
                if (desktopBubble) {
                  desktopBubble.textContent = data.item_count;
                } 
              })
            }

            // Publish cart update event
            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: "cart-items",
              cartData: data
            });
          })
          .catch((error) => {
            console.error("Error updating cart:", error);
          });
      } else {
        // Regular single item removal
        cartItems.updateQuantity(this.dataset.index, 0);
      }
      checkForVirtualBundle();
    });
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector).innerHTML;
  }
}

customElements.define("cart-remove-button", CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();
    this.lineItemStatusElement =
      document.getElementById("shopping-cart-line-item-status") ||
      document.getElementById("CartDrawer-LineItemStatus");

    const debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, ON_CHANGE_DEBOUNCE_TIMER);

    this.addEventListener("change", (event) => {
      if (
        !event.target.classList.contains("show-classic__checkout")
           &&
        !event.target.classList.contains("mm-razor-no_cost_emi")
      ) {
        debouncedOnChange.bind(this);
      }
    });
  }

  cartUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe(
      PUB_SUB_EVENTS.cartUpdate,
      (event) => {
        if (event.source === "cart-items") {
          return;
        }
        this.onCartUpdate();
      }
    );
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

  onChange(event) {
    this.updateQuantity(
      event.target.dataset.index,
      event.target.value,
      document.activeElement.getAttribute("name"),
      event.target.dataset.quantityVariantId,
      event.target.dataset.cartItemInventory
    );
  }

  onCartUpdate() {
    if (this.tagName === "CART-DRAWER-ITEMS") {
      fetch(`${routes.cart_url}?section_id=cart-drawer`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(
            responseText,
            "text/html"
          );
          const selectors = ["cart-drawer-items", ".cart-drawer__footer", "cart-count-bubble"];
          for (const selector of selectors) {
            const targetElement = document.querySelector(selector);
            const sourceElement = html.querySelector(selector);
            if (targetElement && sourceElement) {
              targetElement.replaceWith(sourceElement);
            }
          }
          checkForVirtualBundle();
          
          // Update bundle items after cart update
          const selectedProducts = document.querySelector('selected-products');
          if (selectedProducts) {
            selectedProducts.updateCartDrawerBundleItems();
          }
        })
        .catch((e) => {
          console.error(e);
        });
    } else {
      fetch(`${routes.cart_url}?section_id=main-cart-items`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(
            responseText,
            "text/html"
          );
          const sourceQty = html.querySelector("cart-items");
          this.innerHTML = sourceQty.innerHTML;
          
          // Update bundle items after cart update
          const selectedProducts = document.querySelector('selected-products');
          if (selectedProducts) {
            selectedProducts.updateCartDrawerBundleItems();
          }
        })
        .catch((e) => {
          console.error(e);
        });
    }
  }

  getSectionsToRender() {
    return [
      {
        id: "main-cart-items",
        section: document.getElementById("main-cart-items").dataset.id,
        selector: ".js-contents",
      },
      {
        id: "cart-icon-bubble",
        section: "cart-icon-bubble",
        selector: ".shopify-section",
      },
      {
        id: "cart-live-region-text",
        section: "cart-live-region-text",
        selector: ".shopify-section",
      },
      {
        id: "main-cart-footer",
        section: document.getElementById("main-cart-footer").dataset.id,
        selector: ".js-contents",
      },
    ];
  }

  async updateQuantity(line, quantity, name, variantId, cartItemInventory) {
    this.enableLoading(line);

    // This is done to check the inventory quantity for virtual bundles.
    //  Fetch current cart data
    const cartData = await fetch("/cart.js").then((res) => res.json());
    //  Calculate total quantity in cart for this variant
    let totalQuantity = 0;
    let lineDetails = Number.parseInt(line, 10);
    cartData.items.forEach((item, index) => {
      if (item.id === parseInt(variantId, 10)) {
        const isSameLine = index + 1 === lineDetails;
        totalQuantity += isSameLine
          ? Number.parseInt(quantity, 10)
          : Number.parseInt(item.quantity, 10);
      }
    });

    // Check against available stock
    const maxStock = Number.parseInt(cartItemInventory, 10);
    if (totalQuantity > maxStock) {
      const plusButton = document.querySelector(
        `button[name="plus"][data-variant-id="${variantId}"]`
      );

      const input = document.querySelector(
        `input[data-quantity-variant-id="${variantId}"]`
      );
      if (input) {
        input.stepDown();
      }
      plusButton?.setAttribute("disabled", "true");

      this.updateLiveRegions(line, `Only ${maxStock} items in stock.`);
      this.disableLoading(line);
      return;
    } else {
      const plusButton = document.querySelector(
        `button[name="plus"][data-variant-id="${variantId}"]`
      );
      plusButton?.removeAttribute("disabled");
    }

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });
    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        const quantityElement =
          document.getElementById(`Quantity-${line}`) ||
          document.getElementById(`Drawer-quantity-${line}`);
        const items = document.querySelectorAll(".cart-item");

        if (parsedState.errors) {
          quantityElement.value = quantityElement.getAttribute("value");
          this.updateLiveRegions(line, parsedState.errors);
          return;
        }

        this.classList.toggle("is-empty", parsedState.item_count === 0);
        const cartDrawerWrapper = document.querySelector("cart-drawer");
        const cartFooter = document.getElementById("main-cart-footer");

        if (cartFooter)
          cartFooter.classList.toggle("is-empty", parsedState.item_count === 0);
        if (cartDrawerWrapper)
          cartDrawerWrapper.classList.toggle(
            "is-empty",
            parsedState.item_count === 0
          );

        this.getSectionsToRender().forEach((section) => {
          if (section.id === "cart-icon-bubble") {
            // Use querySelectorAll for 'cart-icon-bubble' and update each element
            const elementsToReplace = document.querySelectorAll(
              `#${section.id}`
            );
            elementsToReplace.forEach((element) => {
              element.innerHTML = this.getSectionInnerHTML(
                parsedState.sections[section.section],
                section.selector
              );
            });
          } else {
            // For other sections, handle as a single element
            const elementToReplace =
              document
                .getElementById(section.id)
                .querySelector(section.selector) ||
              document.getElementById(section.id);

            if (elementToReplace) {
              elementToReplace.innerHTML = this.getSectionInnerHTML(
                parsedState.sections[section.section],
                section.selector
              );
            }
          }
        });
        const updatedValue = parsedState.items[line - 1]
          ? parsedState.items[line - 1].quantity
          : undefined;
        let message = "";
        if (
          items.length === parsedState.items.length &&
          updatedValue !== parseInt(quantityElement.value)
        ) {
          if (typeof updatedValue === "undefined") {
            message = window.cartStrings.error;
          } else {
            message = window.cartStrings.quantityError.replace(
              "[quantity]",
              updatedValue
            );
          }
        }
        this.updateLiveRegions(line, message);

        const lineItem =
          document.getElementById(`CartItem-${line}`) ||
          document.getElementById(`CartDrawer-Item-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
          cartDrawerWrapper
            ? trapFocus(
                cartDrawerWrapper,
                lineItem.querySelector(`[name="${name}"]`)
              )
            : lineItem.querySelector(`[name="${name}"]`).focus();
        } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
          trapFocus(
            cartDrawerWrapper.querySelector(".drawer__inner-empty"),
            cartDrawerWrapper.querySelector("a")
          );
        } else if (document.querySelector(".cart-item") && cartDrawerWrapper) {
          trapFocus(
            cartDrawerWrapper,
            document.querySelector(".cart-item__name")
          );
        }

        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: "cart-items",
          cartData: parsedState,
          variantId: variantId,
        });
        checkForVirtualBundle();
        
        // Update bundle items after quantity update
        const selectedProducts = document.querySelector('selected-products');
        if (selectedProducts) {
          selectedProducts.updateCartDrawerBundleItems();
        }
        
        if (document.querySelector("#discount-toggle-container")) {
          document.querySelector("#discount-toggle-container").style.opacity =
            "1";
          document.querySelector("#discount-toggle-container").style.cursor =
            "pointer";
        }
      })
      .catch(() => {
        this.querySelectorAll(".loading-overlay").forEach((overlay) =>
          overlay.classList.add("hidden")
        );
        const errors =
          document.getElementById("cart-errors") ||
          document.getElementById("CartDrawer-CartErrors");
        errors.textContent = window.cartStrings.error;
      })
      .finally(() => {
        this.disableLoading(line);
      });
  }

  updateLiveRegions(line, message) {
    const lineItemError =
      document.getElementById(`Line-item-error-${line}`) ||
      document.getElementById(`CartDrawer-LineItemError-${line}`);
    if (lineItemError)
      lineItemError.querySelector(".cart-item__error-text").innerHTML = message;

    this.lineItemStatusElement.setAttribute("aria-hidden", true);

    const cartStatus =
      document.getElementById("cart-live-region-text") ||
      document.getElementById("CartDrawer-LiveRegionText");
    cartStatus.setAttribute("aria-hidden", false);

    setTimeout(() => {
      cartStatus.setAttribute("aria-hidden", true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    const mainCartItems =
      document.getElementById("main-cart-items") ||
      document.getElementById("CartDrawer-CartItems");
    mainCartItems.classList.add("cart__items--disabled");

    const cartItemElements = this.querySelectorAll(
      `#CartItem-${line} .loading-overlay`
    );
    const cartDrawerItemElements = this.querySelectorAll(
      `#CartDrawer-Item-${line} .loading-overlay`
    );

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) =>
      overlay.classList.remove("hidden")
    );

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute("aria-hidden", false);
  }

  disableLoading(line) {
    const mainCartItems =
      document.getElementById("main-cart-items") ||
      document.getElementById("CartDrawer-CartItems");
    mainCartItems.classList.remove("cart__items--disabled");

    const cartItemElements = this.querySelectorAll(
      `#CartItem-${line} .loading-overlay`
    );
    const cartDrawerItemElements = this.querySelectorAll(
      `#CartDrawer-Item-${line} .loading-overlay`
    );

    cartItemElements.forEach((overlay) => overlay.classList.add("hidden"));
    cartDrawerItemElements.forEach((overlay) =>
      overlay.classList.add("hidden")
    );
  }
}

customElements.define("cart-items", CartItems);

if (!customElements.get("cart-note")) {
  customElements.define(
    "cart-note",
    class CartNote extends HTMLElement {
      constructor() {
        super();

        const input = this.querySelector("input");

        input.addEventListener(
          "change",
          debounce((event) => {
            const isChecked = event.target.checked;
            const noteValue = isChecked ? "I require a GST bill" : "";
            const body = JSON.stringify({ note: noteValue });
            
            fetch(`${routes.cart_update_url}`, {
              ...fetchConfig(),
              body,
            });
          }, ON_CHANGE_DEBOUNCE_TIMER)
        );
      }
    }
  );
}

async function checkForVirtualBundle() {
  try {
    const response = await fetch("/cart.js");
    if (!response.ok) throw new Error("Failed to fetch cart");
    const data = await response.json();
    for (const item of data.items) {
      if (item.properties && item.properties._virtualBundleMainProductId) {
        window.dontAllowRazorpayCheckout = true;
        return;
      } else {
        window.dontAllowRazorpayCheckout = false;
      }

      if (item.properties && item.properties.CustomImage) {
        window.dontAllowRazorpayCheckout = true;
        return;
      } else {
        window.dontAllowRazorpayCheckout = false;
      }
    }
  } catch (error) {
    console.error("Error fetching cart:", error);
  }
}
